<template>
  <div>

    <!-- 面包屑导航 -->
    <el-breadcrumb separator=">">
      <el-breadcrumb-item>Active Report</el-breadcrumb-item>
      <el-breadcrumb-item>App活跃占比</el-breadcrumb-item>
    </el-breadcrumb>
    <el-divider></el-divider>



    <div id="echart">App 端 活跃行为占比</div>



    <div class="container">
      <div style=" margin-right: 80px; "> </div>


      <div style="margin-bottom: 20px; margin-right: 20px; " size="medium">



        <el-radio-group v-model="radioCycle" style="margin-right: 20px; " size="medium">
          <el-radio-button label="daily">daily</el-radio-button>
          <el-radio-button label="weekly">weekly</el-radio-button>
          <el-radio-button label="monthly">monthly</el-radio-button>
        </el-radio-group>

        <el-radio-group v-model="radioType" style="margin-right: 20px; " size="medium">
          <el-radio-button label="pad">pad</el-radio-button>
          <el-radio-button label="app">app</el-radio-button>
          <el-radio-button label="all">all</el-radio-button>
          <el-radio-button label="xbike">xbike</el-radio-button>
          <el-radio-button label="litbike">litbike</el-radio-button>
          <el-radio-button label="boombike">boombike</el-radio-button>
          <el-radio-button label="boombasic">boombasic</el-radio-button>
          <el-radio-button label="ebike">ebike</el-radio-button>
        </el-radio-group>




      </div>
    </div>

    <el-table :data="tableData" stripe style="width: 100%" height="950"
      :default-sort="{ prop: 'title', order: 'descending' }">

      <el-table-column prop="title" label="日期" width="180" sortable>
      </el-table-column>



      <el-table-column prop="countTotal" label="总次数"> </el-table-column>
      <el-table-column prop="durationTotal" label="总时间"> </el-table-column>


      <el-table-column prop="countApp" label="App次数"> </el-table-column>
      <el-table-column prop="durationApp" label="App时间"> </el-table-column>

      <el-table-column prop="countAppRate" label="App次数占比"> </el-table-column>
      <el-table-column prop="durationAppRate" label="App时间占比"> </el-table-column>



    </el-table>


  </div>
</template>

<script>



export default {
  data() {
    return {
      tableData: [],
      radioCycle: 'weekly',
      radioType: 'pad',
      switchFilter: true,
    }
  },
  // 在 Vue 实例或组件中定义过滤器
  //不知道为什么 现在还没法用, 持续看看吧
  filters: {
    formatDecimal(value) {
      return parseFloat(value).toFixed(2);
    }
  },
  watch: {
    //watch  观察变化
    $route(newVal, oldVal) {
      this.getData(newVal.params.bike_type, newVal.params.cycle)
    },
    //watch  观察变化

    radioCycle(newVal, oldVal) {

      let bike_type = this.$route.params.bike_type;
      this.$router.replace(`/activeDistributionApp/${newVal}/${bike_type}`)
    },


    radioType(newVal, oldVal) {
      let cycle = this.$route.params.cycle;
      this.$router.replace(`/activeDistributionApp/${cycle}/${newVal}`)
    },


  },
  created: function () {
    //注意回调函数的作用域!!!
  },

  methods: {
    async getData(bikeType, cycle) {

      this.tableData = []

      let res = await this.$http.get("/da/active_distribution_app/" + cycle + "/" + bikeType)  //
      this.tableData = res.data
      // console.log(res.data)
      //渲染图表
      this.getLoadEcharts();
    },

    getLoadEcharts() {

      var chart = this.$echarts.init(
        document.getElementById("echart")
      );



      // 创建图表的配置项
      const options = {
        title: {
          text: 'App活跃行为占比' // 添加标题
        },

        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            label: {
              backgroundColor: '#6a7985'
            }
          }
        },

        // 配置项的其他设置...
        xAxis: {
          // 设置横坐标轴的数据
          data: this.tableData.map(item => item.title)
        },
        yAxis: [
  {
    // 主Y轴（左侧）
    type: 'value',
    name: '数量',
    position: 'left',
    // 这里可以添加主Y轴的其他设置，例如axisLabel格式化等
  },
  {
    // 次Y轴（右侧）
    type: 'value',
    name: '百分比',
    position: 'right',
    axisLabel: {
      formatter: '{value} %' // 在次Y轴上以百分比形式显示值
    },
    // 设置次Y轴的刻度与主Y轴分开，避免重叠
    splitLine: {
      show: false
    }
  }
],
toolbox: {
          feature: {
            saveAsImage: {}
          }
        },
        legend: {
          // 添加图例
          data: ['countTotal', 'durationTotal', 'countApp', 'durationApp', 'countAppRate', 'durationAppRate']
        },
        series: [
          {
            name: 'countTotal',
            type: 'bar',
            data: this.tableData.map(item => item.countTotal)
          },
          {
            name: 'durationTotal',
            type: 'bar',
            data: this.tableData.map(item => item.durationTotal)
          },
          {
            name: 'countApp',
            type: 'bar',
            data: this.tableData.map(item => item.countApp)
          },
          {
            name: 'durationApp',
            type: 'bar',
            data: this.tableData.map(item => item.durationApp)
          },
         {
            name: 'countAppRate',
            type: 'line',
            yAxisIndex: 1, // 使用次Y轴（索引1，即第二个Y轴）
            data: this.tableData.map(item => parseFloat(item.countAppRate.replace('%', '')))
          },
          {
           name: 'durationAppRate',//'mini_game','scenic_ride','tour_3d_map'
            type: 'line',
            yAxisIndex: 1, // 使用次Y轴（索引1，即第二个Y轴）
            data: this.tableData.map(item => parseFloat(item.durationAppRate.replace('%', '')))
         },
        ]
      };
      // 使用配置项显示图表
      chart.setOption(options);
    },


    formatDecimal(value) {
      return parseFloat(value).toFixed(2);
    },
  },




  mounted: function () {
    //注意回调函数的作用域!!!

    const bike_type = this.$route.params.bike_type;
    const cycle = this.$route.params.cycle;

    this.getData(bike_type, cycle)
  }



}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.container {
  display: flex;
  justify-content: flex-end;
}

#echart {
  width: 95%;
  height: 450px;
  margin: auto;

}
</style>